type MimeType = {
  type: string
  subtype: string
  parameters: Record<string, string | boolean>
}

export function matchesMimeType(mimeType: string | undefined, match: string) {
  if (!mimeType) return false
  return mimeType.startsWith(match)
}

export function parseMimeType(mimeType?: string): MimeType | undefined {
  if (!mimeType) return undefined

  let [type, subtype] = mimeType.split('/')
  if (!type || !subtype) return undefined

  if (subtype.indexOf(';') != -1) {
    const [realSubtype, ...paramList] = subtype.split(';')
    const parameters = paramList.map((el) => {
      const [k, v] = el.split('=')
      return [k.trim(), v ? v.trim() : true]
    })
    return {
      type,
      subtype: realSubtype.trim(),
      parameters: Object.fromEntries(parameters)
    }
  }

  return { type, subtype, parameters: {} }
}
